import type { AuthValidateRule } from '@webapp/account/src/components/auth/types';
import { useAuthFormField } from '@webapp/account/src/components/auth/useAuthFormField';

import { AuthInput } from './auth-input';

export const AuthFormText: FC<{
    name: string;
    label: string;
    defaultValue: string;
    autoComplete?: string;
    onSubmit?: (v: string) => void;
    rules: AuthValidateRule | Array<AuthValidateRule>;
}> = ({ defaultValue, label, name, onSubmit, rules }) => {
    const { error, focused, handleInputChangeFocus, handleInputChangeValue, value } = useAuthFormField({
        defaultValue,
        name,
        rules,
    });

    return (
        <AuthInput
            error={error}
            focused={focused}
            label={label}
            name={name}
            value={value}
            onBlur={handleInputChangeFocus}
            onChange={handleInputChangeValue}
            onFocus={handleInputChangeFocus}
            onSubmit={onSubmit}
        />
    );
};
